<template>
  <el-dialog title="加工明细" :visible.sync="visible" width="90%" :append-to-body="true">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" :label="$t('orderCode')+'：'">
        <order-drop v-model="queryForm.orderCode" size="mini"></order-drop>
      </el-form-item>
      <el-form-item prop="batchCode" :label="$t('batchCode')+'：'">
        <el-input
            v-model="queryForm.batchCode"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="$t('productName')+'：'">
        <el-input
            v-model="queryForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" :label="$t('productColor')+'：'">
        <el-input
            v-model="queryForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" :label="$t('productSize')+'：'">
        <el-input
            v-model="queryForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：">
        <el-input
            v-model="queryForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="queryForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sellerName" :label="$t('sellerName')+'：'">
        <el-input
            v-model="queryForm.sellerName"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">{{ $t('query') }}</el-button>
        <el-button type="warning" @click="doCheck()" size="mini">确定选择</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :height="500" url="/erp/purchase/page" :is-page="true" api-version="v2"
                :query-form="queryForm" :selection="true"
                :summaries-column="['count','totalPrice','receiveCount']"
    >
      <el-table-column :label="$t('orderCode')" prop="orderCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px"></el-table-column>
      <el-table-column :label="$t('sellerName')" prop="companyName" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px" :formatter="$c.companyNameFormatter"></el-table-column>
      <el-table-column :label="$t('batchCode')" prop="batchCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="120px"></el-table-column>
      <el-table-column label="物料信息" prop="product.code" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true">
        <template #default="{ row }">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划采购数量"
          header-align="center"
          align="center"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="amount"
          label="计划采购单价"
          header-align="center"
          align="center"
          width="120"
      ></el-table-column>

    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  name: 'make-detail-dialog',
  components: { ProductRowCard },
  mixins: [SweetTable],
  props: {
    disabledQuery: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      visible: false,
      queryForm: {
        makeId: null,
        exIds: [],
        sellerId: null,
        customerId: null,
        showCompletedOrder: false,
        orderCode: null,
        batchCode: null,
        productCode: null,
        productSkuCode: null,
        productName: null,
        productNameZh: null,
        productColor: null,
        productSize: null,
        sellerName: null,
        orderPrice: 'Y',
        orderCompleted:'N'
      },
    }
  },
  methods: {
    doCheck () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('未选择数据')
      }
      this.$emit('selected', rows)
      this.clearSelection()
      this.visible = false
    },
    init (exIds) {
      this.visible = true
      if (exIds instanceof Array) {
        this.queryForm.exIds = exIds.join(',')
      } else if (exIds instanceof String) {
        this.queryForm.exIds = exIds
      }
      this.$nextTick(() => {
        this.reload()
      })
    }
  }
}
</script>

<style scoped>

</style>
